import { NextPage, GetServerSidePropsContext } from "next";
import { ENDPOINT_CONTENT_ID } from "lib/graphql/endpoints";
import { extractScript, replaceStyleTag, stringMinify } from "utils/StringUtils";
import getSettings from "utils/getSettings";
import dynamic from "next/dynamic";

const HtmlComponent = dynamic(() => import("components/Html/Html"));

interface IAboutProps {
  styles: string;
  scripts: string;
  htmlpage: string;
}

const AboutPage: NextPage<IAboutProps> = ({
    styles,
    scripts,
    htmlpage,
}) => {

    const styleInline = replaceStyleTag(styles);
    const scriptsInline = extractScript(scripts);

    return (
        <>
            {styleInline && (
                <style jsx>{`
            ${stringMinify(styleInline)}
          `}</style>
            )}
            {scriptsInline && (
                <script>{`
            ${stringMinify(scriptsInline)}
          `}</script>
            )}
            <HtmlComponent htmlValue={htmlpage} />
        </>
    );
};

export const getServerSideProps = async ({ res, req }: GetServerSidePropsContext) => {
    res.setHeader(
        'Cache-Control',
        `public, s-maxage=${process.env.CACHE_CONTROL_MAX}, stale-while-revalidate=${process.env.CACHE_CONTROL_MAX}`
    );
    const contentIds = [ENDPOINT_CONTENT_ID.ABOUT_PAGE_SETTINGS];
    const { settings, websiteContent } = await getSettings(req, contentIds);

    try {
        const content =
        websiteContent?.find(
            (item) => item?.key === ENDPOINT_CONTENT_ID.ABOUT_PAGE_SETTINGS
        ) || null;
        const json = JSON.parse(stringMinify(content?.value || ""));

        return {
            props: {
                titlePage: json.titlePage ?? 'About',
                friendlyUrl: json.friendlyUrl,
                keywords: json.keywords,
                metaDescription: json.metaDescription,
                ...json,
                settings,
            },
        };
    } catch {
        return {
            notFound: true,
        };
    }
};

export default AboutPage;
